
// Vue
import {Options, Vue} from "vue-class-component";

@Options({})
export default class AdministratorMatchesNavigationVue extends Vue {}
